export enum NoItemPlaceholderSize {
    XxSmall = 'xx-small',
    XSmall = 'x-small',
    Small = 'small', 
    Normal = 'normal',
    Large = 'large',
    XLarge = 'x-large',
    XxLarge = 'xx-large',
    XxxLarge = 'xxx-large'
}